import api from '../api/api';
import { RestaurantAttendance, RestaurantPage } from '../types/restaurantPersonnel';

export const loadRestaurantAttendanceReport = async (
  url: string,
  employmentId: number,
  range: { dateFrom: string; dateTo: string },
  signal: AbortSignal,
  isCurrent: () => boolean,
): Promise<RestaurantAttendance[]> => {
  const items: RestaurantAttendance[] = [];
  const intervalIds = new Set<number>();
  let total = 0;
  let snapshotVersion = '';
  for (let page = 1; ; page++) {
    const response = await api.get<RestaurantPage<RestaurantAttendance>>(url, {
      signal, params: { ...range, page, pageSize: 100, reportSnapshot: true },
    });
    if (signal.aborted || !isCurrent()) throw new DOMException('Report cancelled', 'AbortError');
    const result = response.data;
    if (typeof result.snapshotVersion !== 'string' || !result.snapshotVersion ||
        result.page !== page || result.pageSize !== 100 || !Array.isArray(result.items))
      throw new Error('Не вдалося підтвердити узгодженість табеля працівника. Повторіть друк.');
    if (page === 1) {
      total = result.total;
      snapshotVersion = result.snapshotVersion;
    }
    if (!Number.isSafeInteger(total) || total < 0 || result.total !== total ||
        result.snapshotVersion !== snapshotVersion || result.items.length > 100 ||
        (items.length < total && !result.items.length))
      throw new Error('Табель змінився під час завантаження. Повторіть друк.');
    for (const interval of result.items) {
      if (interval.employmentId !== employmentId || !Number.isSafeInteger(interval.id) ||
          interval.id <= 0 || intervalIds.has(interval.id))
        throw new Error('Склад табеля працівника змінився під час завантаження. Повторіть друк.');
      intervalIds.add(interval.id);
    }
    items.push(...result.items);
    if (items.length > total)
      throw new Error('Склад табеля працівника змінився під час завантаження. Повторіть друк.');
    if (items.length === total) return items;
  }
};
